import {
  Container,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  MenuItem,
  Select,
} from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const Approved = () => {
  const classes = useStyles();
  const [view, setView] = React.useState("");

  const handleChange = (event) => {
    setView(event.target.value);
  };
  return (
    <div className="approvalPage">
      <div className="approvalHeading">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTitle">RFQ No</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTitle">Customer Name</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              {" "}
              <h5 className="approvalTitle">Contact Person</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              {" "}
              <h5 className="approvalTitle">Email</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTitle">Contact Number</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTitle">Country</h5>
              <input type="text" className="approvalInput" />
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTitle">Actions</h5>
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className="approvalTabel">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">1</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">Nestle</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">John Doe</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">john@tristar-group.co</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">0524394389</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Saudi</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-autowidth-label">
                  View
                </InputLabel>
                <Select
                  value={view}
                  onChange={handleChange}
                  displayEmpty
                  defaultValue={"Approve"}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value={"Request Document"}>
                    Request Document
                  </MenuItem>
                  <MenuItem value={"View RFQs"}>View RFQs</MenuItem>
                  <MenuItem value={"Disable Customer"}>
                    Disable Customer
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className="approvalTabel">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">1</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">Nestle</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">John Doe</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">john@tristar-group.co</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">0524394389</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Saudi</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-autowidth-label">
                  View
                </InputLabel>
                <Select
                  value={view}
                  onChange={handleChange}
                  displayEmpty
                  defaultValue={"Approve"}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value={"Request Document"}>
                    Request Document
                  </MenuItem>
                  <MenuItem value={"View RFQs"}>View RFQs</MenuItem>
                  <MenuItem value={"Disable Customer"}>
                    Disable Customer
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className="approvalTabel">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">1</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">Nestle</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">John Doe</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">john@tristar-group.co</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">0524394389</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Saudi</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-autowidth-label">
                  View
                </InputLabel>
                <Select
                  value={view}
                  onChange={handleChange}
                  displayEmpty
                  defaultValue={"Approve"}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value={"Request Document"}>
                    Request Document
                  </MenuItem>
                  <MenuItem value={"View RFQs"}>View RFQs</MenuItem>
                  <MenuItem value={"Disable Customer"}>
                    Disable Customer
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Container>
      </div>
      <div className="approvalTabel">
        <Container>
          <Grid container spacing={2}>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">1</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">Nestle</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">John Doe</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">john@tristar-group.co</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <h5 className="approvalTabelTitle">0524394389</h5>
            </Grid>
            <Grid item xs={12} lg={1} md={1}>
              <h5 className="approvalTabelTitle">Saudi</h5>
            </Grid>
            <Grid item xs={12} lg={2} md={2}>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel id="demo-simple-select-autowidth-label">
                  View
                </InputLabel>
                <Select
                  value={view}
                  onChange={handleChange}
                  displayEmpty
                  defaultValue={"Approve"}
                  inputProps={{ "aria-label": "Without label" }}
                >
                  <MenuItem value={"Request Document"}>
                    Request Document
                  </MenuItem>
                  <MenuItem value={"View RFQs"}>View RFQs</MenuItem>
                  <MenuItem value={"Disable Customer"}>
                    Disable Customer
                  </MenuItem>
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Container>
      </div>
    </div>
  );
};

export default Approved;
